var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShelter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 90H42v6h63v-6ZM103.885 18.218l-90 35.997 2.228 5.571 90-35.998-2.228-5.57ZM96 69H48v6h48v-6ZM90.17 60H54v6h36.17v-6Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m84.046 62.52-5.923.959 2.915 18 5.923-.96-2.915-18ZM60.124 62.489l-3.083 18 5.913 1.013 3.084-18-5.914-1.013ZM30.3 70.8c-5.128 0-9.3-4.172-9.3-9.3 0-5.127 4.172-9.3 9.3-9.3 5.128 0 9.3 4.172 9.3 9.3 0 5.127-4.172 9.3-9.3 9.3Zm0-12.6c-1.82 0-3.3 1.48-3.3 3.3 0 1.82 1.48 3.3 3.3 3.3 1.82 0 3.3-1.48 3.3-3.3 0-1.82-1.48-3.3-3.3-3.3Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 83.4c-5.128 0-9.3-4.172-9.3-9.3 0-5.127 4.172-9.3 9.3-9.3 5.128 0 9.3 4.172 9.3 9.3 0 5.128-4.172 9.3-9.3 9.3Zm0-12.6c-1.82 0-3.3 1.48-3.3 3.3 0 1.82 1.48 3.3 3.3 3.3 1.82 0 3.3-1.48 3.3-3.3 0-1.82-1.48-3.3-3.3-3.3Z",
    fill: "#222",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 96c-5.128 0-9.3-4.172-9.3-9.3 0-5.127 4.172-9.3 9.3-9.3 5.128 0 9.3 4.172 9.3 9.3 0 5.127-4.172 9.3-9.3 9.3Zm0-12.6c-1.82 0-3.3 1.48-3.3 3.3 0 1.82 1.48 3.3 3.3 3.3 1.82 0 3.3-1.48 3.3-3.3 0-1.82-1.48-3.3-3.3-3.3Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelter);
export default __webpack_public_path__ + "static/media/shelter.08206141.svg";
export { ForwardRef as ReactComponent };